import React from 'react';

const StatsSection: React.FC = () => {
  const stats = [
    {
      number: '500+',
      label: 'Happy Clients',
      icon: 'ri-user-smile-line'
    },
    {
      number: '2,000+',
      label: 'Projects Completed',
      icon: 'ri-building-line'
    },
    {
      number: '15+',
      label: 'Years Experience',
      icon: 'ri-calendar-line'
    },
    {
      number: '98%',
      label: 'Customer Satisfaction',
      icon: 'ri-heart-line'
    }
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our <strong>Impact</strong> in Numbers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These numbers reflect our commitment to excellence and the trust South Carolina businesses place in us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-2xl text-orange-500`}></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;